import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import {
  Container,
  CardGroup,
  Card,
  CardContent,
  Image,
  Button
} from 'semantic-ui-react'

export default function ShowServices() {
  const [state] = useState({
    startCount: 0
  })

  const services = [
    { name: 'Tree Removal', image: '/images/our-tree-removal.jpg' },
    { name: 'Stump Grinding', image: '/images/our-stump-grinding.jpg' },
    { name: 'Trimming', image: '/images/our-trimming.jpg' },
    { name: 'Chipping', image: '/images/our-chipping.jpg' }
  ]
  const showCount = 3

  const { startCount } = state
  const items = []
  for (let i = startCount; i < showCount + startCount; i++) {
    const service = services[i]
    items.push(
      <Card key={i}>
        <CardContent verticalAlign="middle">
          <Image src={service.image} as={Link} to="/services" />
        </CardContent>
      </Card>
    )
  }

  return (
    <div className="show-services-area">
      <Container style={{ textAlign: 'center' }}>
        <h1
          className="reviews-title"
          style={{ fontSize: '2.1em', marginBottom: '1em' }}>
          Services
        </h1>
        {/* <h1 className="title">What homeowners are saying.</h1> */}

        <CardGroup centered>{items}</CardGroup>
        <Button
          color="green"
          style={{ margin: '20px 0 0 0' }}
          size="large"
          as={Link}
          to="/services">
          More Services
        </Button>
      </Container>
    </div>
  )
}
